import { createQueryKeys } from '@lukemorales/query-key-factory';

import { get } from '@/api/api';
import type { FanguardApiContractsPersonEnrolledCampaignSummaryModel } from 'src/api/generated';

export const ENROLLMENT_URI = 'enrollment';

export const enrollmentQueries = createQueryKeys(ENROLLMENT_URI, {
  all: null,
  byPerson: (personId: string) => ({
    queryKey: [personId],
    queryFn: async () => {
      const response = await get<FanguardApiContractsPersonEnrolledCampaignSummaryModel[]>({
        uri: `${ENROLLMENT_URI}/${personId}`,
      });
      return response.data;
    },
  }),
});
